import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import historyFourTrainersData from '../data/HistoryFour';
import './HistoryFour.css';

const HistoryFourTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(historyFourTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('🧭 Explorer/Adventurous Soul selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/history-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/history-train-categories');
    };

    return (
        <div className="history-trainers-container">
            <div className="history-animated-background horizon-flow"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="history-trainers-header">
                <div className="header-content">
                    <h1>Explorers & Adventurous Souls</h1>
                    <p>Train with legendary explorers, navigators, and frontier pioneers</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Exploration & Adventure</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="history-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="history-trainer-card floating-exploration-element discovery-wind compass-pulse"
                        onClick={() => handleTrainerSelect(trainer)}
                        data-character={trainer.id}
                        style={{
                            '--history-primary-color': trainer.color,
                            '--history-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Character-specific accent icons */}
                        {trainer.id === 'marco-polo' && <div className="compass-navigation-accent"></div>}
                        {trainer.id === 'christopher-columbus' && <div className="ship-accent"></div>}
                        {trainer.id === 'lewis-clark' && <div className="mountain-accent"></div>}
                        {trainer.id === 'ernest-shackleton' && <div className="ship-accent"></div>}
                        {trainer.id === 'amelia-earhart' && <div className="plane-accent"></div>}
                        {trainer.id === 'wild-bill-hickok' && <div className="pistol-accent"></div>}

                        {/* Trainer Image */}
                        <div className="history-trainer-image-section">
                            <div
                                className="history-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="adventure-horizon-effect"></div>
                                <div className="experience-badge history-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="history-trainer-info-section map-texture">
                            <h3 className="history-trainer-name">{trainer.name}</h3>
                            <p className="history-trainer-specialization">{trainer.specialization}</p>
                            <p className="history-trainer-description">{trainer.intro}</p>

                            <div className="history-trainer-details">
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">🗺️</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">🧭</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Adventure Divider */}
            <div className="adventure-divider"></div>

            {/* Footer */}
            <div className="history-trainers-footer voyage-pattern">
                <div className="history-info">
                    <h3>Explorers & Adventurous Souls Philosophy</h3>
                    <div className="history-benefits-grid">
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🛤️</div>
                            <div>
                                <strong>Silk Road Endurance Journey</strong>
                                <p>24-year expedition conditioning that builds bridges between civilizations across hostile territories</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🌊</div>
                            <div>
                                <strong>Atlantic Ocean Navigation</strong>
                                <p>New World discovery training that sails into terrifying unknowns with unwavering determination</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🏔️</div>
                            <div>
                                <strong>Continental Wilderness Mapping</strong>
                                <p>Corps of Discovery conditioning that surveys virgin territories from Missouri to the Pacific</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🧊</div>
                            <div>
                                <strong>Antarctic Crisis Leadership</strong>
                                <p>Ice survival training that maintains hope and saves every crew member in impossible circumstances</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">✈️</div>
                            <div>
                                <strong>Aviation Pioneer Courage</strong>
                                <p>Sky-breaking conditioning that shatters gender barriers and inspires generations to reach for the heavens</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🤠</div>
                            <div>
                                <strong>Frontier Justice Reflexes</strong>
                                <p>Lightning gunfighter training that brings order to the wildest towns with quick-draw precision</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoryFourTrainers;